module.exports = __webpack_public_path__ + "static/media/register-1366w.c583a849.jpg";